import { Loader } from '@googlemaps/js-api-loader'

const apiKey = 'AIzaSyCw_KJcdULwyy-_6UchKQEbmCrGHgJTNXM'
const loader = new Loader({
    apiKey,
    version: 'weekly',
})

const { Map, InfoWindow } = await loader.importLibrary('maps')
const { Marker, Animation } = await loader.importLibrary('marker')
const { Autocomplete } = await loader.importLibrary('places')
const { LatLngBounds } = await loader.importLibrary('core')
// const { Size } = await loader.importLibrary('core')

class VpStoreLocator {
    dom
    map
    infoWindow
    autocomplete
    markers = []
    center
    zoom
    defaultCenter
    defaultZoom
    overZoom = 9
    distanceFrom

    constructor(el) {
        this.dom = {
            el,
            filters: {
                autocomplete: el.querySelector(
                    ':scope > .container > .filters .autocomplete'
                ),
                agence: el.querySelector(
                    ':scope > .container > .filters .agence'
                ),
                zone: el.querySelector(':scope > .container > .filters .zone'),
                reset: el.querySelector(
                    ':scope > .container > .filters .reset'
                ),
            },
            list: el.querySelector(':scope > .container > .view > .list'),
            items: el.querySelectorAll(
                ':scope > .container > .view > .list > .item'
            ),
            map: el.querySelector(':scope > .container > .view > .map'),
        }

        this.defaultZoom = parseInt(el.dataset.zoom || 7)
        this.defaultCenter = {
            lat: parseFloat(el.dataset.lat || 0),
            lng: parseFloat(el.dataset.lng || 0),
        }

        this.center = this.defaultCenter
        this.zoom = this.defaultZoom
        this.map = new Map(this.dom.map, {
            zoom: this.zoom,
            center: this.center,
        })
        this.infoWindow = new InfoWindow({ maxWidth: 350 })

        this.dom.filters.autocomplete.value = ''
        this.autocomplete = new Autocomplete(this.dom.filters.autocomplete, {
            fields: ['geometry'],
        })
        this.autocomplete.addListener(
            'place_changed',
            this.placeChanged.bind(this)
        )

        this.initFilters()
        this.setMarkers()
        this.filter()
        // console.log(this)
    }

    initFilters() {
        const data = [...this.dom.items].map((item) => ({ ...item.dataset }))

        // clone from data
        let options = data.map((row) => ({
            id: row.agenceId || '',
            label: row.agenceLabel || '',
        }))

        // unique
        options = options.filter(
            (obj, i) => options.findIndex((item) => item.id === obj.id) === i
        )

        // sort by label
        options = options.sort((a, b) => a.label.localeCompare(b.label))

        // to html
        options = options.map(
            (item) => `<option value="${item.id}">${item.label}</option>`
        )

        this.dom.filters.agence.innerHTML = `<option value="">Agence...</option>${options}`
        this.dom.filters.agence.addEventListener(
            'input',
            this.filter.bind(this)
        )

        this.dom.filters.reset.addEventListener('click', this.reset.bind(this))
    }

    setMarkers() {
        const map = this.map
        const infoWindow = this.infoWindow
        const items = this.dom.items

        for (const item of items) {
            const lat = parseFloat(item.dataset.lat)
            const lng = parseFloat(item.dataset.lng)
            const position = { lat, lng }
            const title = item.querySelector('.title')?.textContent || '[title]'
            const infos = item.querySelector('.infos') || '[infos]'
            const marker = new Marker({ position, map, title })
            marker.addListener('click', () => {
                infoWindow.close()
                infoWindow.setContent(infos)
                infoWindow.open(map, marker)
            })
            const over = (e) => {
                if (!e.target) {
                    // item.scrollIntoView({
                    //     block: 'center',
                    //     inline: 'nearest',
                    //     behavior: 'smooth',
                    // })
                }
                this.dom.list
                    .querySelector(':scope > .over')
                    ?.classList.remove('over')
                item.classList.add('over')
                marker.setAnimation(Animation.BOUNCE)
            }
            const out = () => {
                item.classList.remove('over')
                marker.setAnimation(null)
            }
            const click = () => {
                this.center = { lat, lng }
                this.map.setCenter(this.center)
                this.map.setZoom(this.overZoom)
            }
            item.addEventListener('mouseenter', over)
            item.addEventListener('mouseleave', out)
            item.addEventListener('click', click)
            marker.addListener('mouseover', over)
            marker.addListener('mouseout', out)

            this.markers.push(marker)
        }
        this.map = map
    }

    filter() {
        const agence = this.dom.filters.agence.value
        const items = this.dom.items

        for (const [i, item] of items.entries()) {
            // init
            let visible = true

            // check agence
            const itemAgence = item.dataset?.agenceId || ''
            if (agence !== '' && itemAgence !== agence) {
                visible = false
            }

            if (this.distanceFrom) {
                item.dataset.distance = this.distance(
                    this.distanceFrom.lat,
                    this.distanceFrom.lng,
                    parseFloat(item.dataset.lat || 0),
                    parseFloat(item.dataset.lng || 0)
                )
                this.sortByDistance()
            } else {
                this.sortByTitle()
            }

            // filtering list items + markers
            item.classList.toggle('visible', visible)
            this.markers[i].setVisible(visible)
        }

        if (this.distanceFrom) {
            // use geocoded location + first marker
            const firstItem = this.dom.list.querySelector(':scope > .item')
            let firstLatLng = null
            if (firstItem) {
                firstLatLng = {
                    lat: parseFloat(firstItem.dataset.lat || 0),
                    lng: parseFloat(firstItem.dataset.lng || 0),
                }
            }
            const bounds = new LatLngBounds()
            bounds.extend(this.distanceFrom)
            bounds.extend(firstLatLng)
            this.map.fitBounds(bounds)
        } else {
            // use centering
            this.map.setCenter(this.center)
            this.map.setZoom(this.zoom)
        }
    }

    placeChanged() {
        this.infoWindow.close()
        const place = this.autocomplete.getPlace()
        if (place.geometry?.location) {
            // console.log('place ok')
            this.distanceFrom = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            }
            this.center = this.distanceFrom
            this.zoom = this.overZoom
            // this.dom.filters.autocomplete.value = ''
        } else {
            // console.log('place ko')
            this.distanceFrom = null
            this.center = this.defaultCenter
            this.zoom = this.defaultZoom
        }
        this.map.setCenter(this.center)
        this.map.setZoom(this.zoom)
        this.filter()
    }

    reset() {
        this.center = this.defaultCenter
        this.zoom = this.defaultZoom
        this.dom.filters.autocomplete.value = ''
        this.distanceFrom = null
        this.dom.filters.agence.value = ''
        this.filter()
    }

    sortByTitle() {
        ;[...this.dom.items]
            .sort((a, b) =>
                (a.querySelector('.title')?.textContent || '') >
                (b.querySelector('.title')?.textContent || '')
                    ? 1
                    : -1
            )
            .forEach((node) => this.dom.list.appendChild(node))
    }

    sortByDistance() {
        ;[...this.dom.items]
            .sort((a, b) =>
                parseFloat(a.dataset.distance || 999999) >
                parseFloat(b.dataset.distance || 999999)
                    ? 1
                    : -1
            )
            .forEach((node) => this.dom.list.appendChild(node))
    }

    distance(lat1, lng1, lat2, lng2) {
        const R = 6371 // km
        const dLat = this.toRadian(lat2 - lat1)
        const dLon = this.toRadian(lng2 - lng1)
        const lat1Radian = this.toRadian(lat1)
        const lat2Radian = this.toRadian(lat2)

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) *
                Math.sin(dLon / 2) *
                Math.cos(lat1Radian) *
                Math.cos(lat2Radian)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        const d = R * c
        return d
    }

    toRadian(v) {
        return (v * Math.PI) / 180
    }
}

for (const el of document.querySelectorAll('.vp-store-locator')) {
    new VpStoreLocator(el)
}
